/**
 * The statutes an officer's appointment may confer authority under.
 *
 * **Why this lives here and only here.** These three codes were declared five
 * separate times — twice in the contracts packages, once in the database
 * entity's type, once more as a differently-named alias, and once as a local
 * `const` inside the Government Portal's appoint dialog — with two further
 * comments restating the values. Every copy agreed, which is exactly what made
 * it dangerous: nothing failed, so nothing pointed at the other four. Adding a
 * fourth statute meant finding all five, and the one that got missed would be a
 * dialog quietly offering an officer less authority than the law gives them.
 *
 * `libs/access` owns it because it already owns roles and permissions, it
 * depends on nothing, and both contracts packages depend on it — so admin and
 * the Government Portal cannot drift apart on what an officer may act under.
 *
 * The codes are New Brunswick's: the Local Governance Act, the Community
 * Planning Act, and the Building Code Administration Act.
 */
export const APPOINTMENT_AUTHORITIES = ['LGA', 'CPA', 'BCAA'] as const;
export type AppointmentAuthority = (typeof APPOINTMENT_AUTHORITIES)[number];
